module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image6.6a77ff13.webp";